// extracted by mini-css-extract-plugin
export default {"innerWrapper":"lz-z","tooltipWrapper":"mz-z","icon":"nz-z","tooltip":"oz-z","content":"pz-z"};